<div>
  <div class="verification-title-text" i18n>{{ 'Verification is needed to complete your log in' }}</div>
  <div class="auth-flow-subtext" i18n>
    {{
      'Scan the QR code below using the authenticator app of your choice such as Google Authenticator, Authy, or Windows Phone Authenticator.'
    }}
  </div>
  <ng-container *ngIf="viewModel.isMobile$ | async">
    <div class="subtext pt-3">
      <ng-container i18n>On Mobile? Click</ng-container>
      <a class="paddingless-text-button copy-text" (click)="clipboardService.copyToClipboard(mfaKey)">
        <ng-container i18n>here</ng-container>
      </a>
      <ng-container i18n>to copy the code to your clipboard.</ng-container>
    </div>
    <hr />
  </ng-container>
</div>
<div>
  <canvas id="qr-code"></canvas>
  <button class="paddingless-text-button qr-support" (click)="openSupportModal()">
    <ng-container i18n>QR Code Support</ng-container>
  </button>
</div>

<div class="auth-flow-subtext pb-4" i18n>
  {{ 'After scanning the QR code, you will be given a six-digit verification code. Please enter it below.' }}
</div>

<form [formGroup]="formGroup" class="d-flex flex-column gap-4 pb-4">
  <div class="d-flex flex-column gap-2">
    <label for="timeBasedOneTimePassword" class="form-input-label" i18n>Verification Code</label>
    <app-masked-text-input
      formControlName="code"
      controlId="timeBasedOneTimePassword"
      [maskOptions]="codeMaskOptions"
      (keydown.enter)="submit()"
      [error]="formSubmitted && formGroup.controls.code.invalid" />
    <app-form-error
      *ngIf="formSubmitted && formGroup.controls.code.invalid"
      [customErrorMessages]="customErrorMessages.code"
      [errors]="formGroup.controls.code.errors" />
  </div>
</form>
<app-primary-button class="w-100" [width]="'100%'" i18n (buttonClicked)="submit()">
  {{ 'Verify Account' }}
</app-primary-button>
<div class="internal-support-button-container" i18n>
  <span>{{ 'Having trouble?' }}</span>
  <button class="paddingless-text-button support-text mt-2" (click)="viewModel.openContactPage()">
    {{ 'Click here for support' }}
  </button>
</div>
